import { PaymentStatusEnum } from '../models';

export const paymentStatus: {
  [key in PaymentStatusEnum]: PaymentStatusEnum;
} = {
  initial: 'initial',
  cancelled: 'cancelled',
  approved: 'approved',
  refunded: 'refunded',
  rejected: 'rejected',
};

export const paymentStatusTranslate = {
  initial: 'inicial',
  approved: 'aprobado',
  cancelled: 'cancelado',
  refunded: 'reembolsado',
};
